import { gql } from '@parkchirp/api-client';

export const UPDATE_INVOICE_DUE_DATE = gql`
    mutation updateInvoiceDueDate(
        $invoiceId: String!
        $dueDate: String!
    ) {
        updateInvoiceDueDate(
            invoiceId: $invoiceId
            dueDate: $dueDate
        )
    }
`;

export const SYNC_INVOICE_IN_CACHE = gql`
mutation syncInvoiceInCache(
  $invoiceId: String!
) {
  syncInvoiceInCache(
    invoiceId: $invoiceId
  ) 
}
`;
